// ./ScoreUploader.js

const uploadScore = async (name, score, className) => {
  const baseUrl = 'https://script.google.com/macros/s/AKfycbzw5-Sl0MjY7K1MHAq9yeKGEYrmNUCk4aUeBCXhwZpgDGschK992PccA_eJkT_ZODMZWw/exec';

  // Construct query parameters
  const params = new URLSearchParams({
    action: 'addScore',
    name: name.trim(),
    score: score,
    className: className.trim(), // Ensure the parameter name matches the server's expectation
  });

  const url = `${baseUrl}?${params.toString()}`;

  try {
    const response = await fetch(url, {
      method: 'GET', // Use GET since doGet handles GET requests
    });

    if (!response.ok) {
      // Attempt to parse the error message from the response
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to upload score');
    }

    const data = await response.json();

    if (data.status !== 'success') {
      throw new Error(data.message || 'Failed to upload score');
    }

    return data;
  } catch (error) {
    console.error('Error uploading score:', error);
    throw error;
  }
};

export default uploadScore;
